function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#line-info-blck_svg__dtd2ptv6ba)"
}, React.createElement("path", {
  d: "M9.167 5.833h1.666V7.5H9.167V5.833zm0 3.334h1.666v5H9.167v-5zm.833-7.5A8.336 8.336 0 001.667 10c0 4.6 3.733 8.333 8.333 8.333S18.333 14.6 18.333 10 14.6 1.667 10 1.667zm0 15A6.676 6.676 0 013.333 10 6.676 6.676 0 0110 3.333 6.675 6.675 0 0116.667 10 6.675 6.675 0 0110 16.667z",
  fill: "#3B3B3B"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "line-info-blck_svg__dtd2ptv6ba"
}, React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})));

var SvgLineInfoBlck = function SvgLineInfoBlck(props) {
  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cg clip-path='url(%23dtd2ptv6ba)'%3E %3Cpath d='M9.167 5.833h1.666V7.5H9.167V5.833zm0 3.334h1.666v5H9.167v-5zm.833-7.5A8.336 8.336 0 0 0 1.667 10c0 4.6 3.733 8.333 8.333 8.333S18.333 14.6 18.333 10 14.6 1.667 10 1.667zm0 15A6.676 6.676 0 0 1 3.333 10 6.676 6.676 0 0 1 10 3.333 6.675 6.675 0 0 1 16.667 10 6.675 6.675 0 0 1 10 16.667z' fill='%233B3B3B'/%3E %3C/g%3E %3Cdefs%3E %3CclipPath id='dtd2ptv6ba'%3E %3Cpath fill='%23fff' d='M0 0h20v20H0z'/%3E %3C/clipPath%3E %3C/defs%3E %3C/svg%3E";
export { SvgLineInfoBlck as ReactComponent };